import {CSSProperties, FC} from 'react';


export interface IIconTradeInNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTradeInNissan: FC<IIconTradeInNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M15.7 14.808h2.628a.8.8 0 0 1 .776.792v2.6a.8.8 0 0 1-1.6 0v-.416A8 8 0 0 1 4 12a.8.8 0 0 1 1.6 0 6.4 6.4 0 0 0 11.024 4.408H15.7a.8.8 0 0 1 0-1.6ZM6.496 6.216A8 8 0 0 1 12 4a8 8 0 0 1 8 8 .8.8 0 0 1-1.6 0A6.4 6.4 0 0 0 7.376 7.6H8.3a.8.8 0 1 1 0 1.6H5.696a.8.8 0 0 1-.8-.8V5.8a.8.8 0 1 1 1.6 0v.416Zm7.542 4.991h.112c.58 0 1.05.459 1.05 1.025v1.024a.346.346 0 0 1-.35.342h-.7c0 .565-.12.902-.7.902s-.817-.337-.817-.902H10.65c0 .565-.12.902-.7.902s-.7-.337-.7-.902h-.7a.355.355 0 0 1-.248-.1.337.337 0 0 1-.102-.242v-1.024c0-.566.47-1.025 1.05-1.025h.063l.182-.884c.099-.48.531-.824 1.033-.823h2.1c.428 0 .813.254.973.642l.437 1.065Z" clipRule="evenodd" />
        </svg>
    );
};
